import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse
} from '@material-ui/core';

import DownIcon from '@material-ui/icons/KeyboardArrowDown';
import UpIcon from '@material-ui/icons/KeyboardArrowUp';

import { useSelector } from 'react-redux';

import { getTicketCheckinSummary } from '../../../../store/ticket';

const Summary = props => {
  // const {couponsCount } = props;
  const summaryData = useSelector(getTicketCheckinSummary);
  const [summary, setSummary] = useState({});

  useEffect(() => {
    // console.log('useEffect usersData',usersData);
    setSummary(summaryData);
  }, [summaryData]);

  const [collapse, setCollapse] = useState(false);

  const handleCollapse = async () => {
    setCollapse(!collapse);
  };

  // console.log('summary', summary);
  return (
    <Card>
      {summary && Object.keys(summary).length > 0 && (
        <Fragment>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <IconButton
                    aria-label="minus"
                    onClick={handleCollapse}
                    size="small">
                    {!collapse && <DownIcon />}
                    {collapse && <UpIcon />}
                  </IconButton>
                </TableCell>
                <TableCell>Все {!collapse ? summary.all.total : ''}</TableCell>
                <TableCell>
                  😃 {!collapse ? summary.customers.total : ''}
                </TableCell>
                <TableCell>😻 {!collapse ? summary.team.total : ''}</TableCell>
                <TableCell>
                  🔥 {!collapse ? summary.special.total : ''}
                </TableCell>
              </TableRow>
            </TableHead>
          </Table>

          <Collapse in={collapse}>
            <Table>
              {/* <TableHead>
                <TableRow>
                  <TableCell>
                    <IconButton
                      aria-label="minus"
                      onClick={handleCollapse}
                      size="small">
                      <UpIcon />
                    </IconButton>
                  </TableCell>
                  <TableCell>Всего</TableCell>

                  <TableCell>😃</TableCell>
                  <TableCell>😻</TableCell>
                </TableRow>
              </TableHead> */}
              <TableBody>
                <TableRow>
                  <TableCell>Всего</TableCell>
                  <TableCell>
                    <Typography variant="h5">{summary.all.total}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h5">
                      {summary.customers.total}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h5">{summary.team.total}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h5">
                      {summary.special.total}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Выдано</TableCell>
                  <TableCell>
                    <Typography variant="h5">{summary.all.checked}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h5">
                      {summary.customers.checked}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h5">{summary.team.checked}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h5">
                      {summary.special.checked}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Осталось</TableCell>
                  <TableCell>
                    <Typography variant="h5">{summary.all.remain}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h5">
                      {summary.customers.remain}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h5">{summary.team.remain}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h5">
                      {summary.special.remain}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Collapse>
        </Fragment>
      )}
    </Card>
  );
};

Summary.propTypes = {
  className: PropTypes.string
};

export default Summary;
